export const API_URL: string = "https://norma.nomoreparties.space/api";
export const wsUrl: string = "wss://norma.nomoreparties.space/orders";